// extracted by mini-css-extract-plugin
export default {"container":"StandardStep_container__O5bYQ","rightButtons":"StandardStep_rightButtons__+NsAk"};